<template>
    <section class="auth-frame">
        <section class="auth invite">
            <div class="auth-spacer"/>
            <div class="auth-body">
                <div class="auth-elements">
                    <div class="auth-logo">
                        <div class="auth-shadow"/>
                    </div>

                    <div v-if="step == -2">
                        <app-alert v-if="errorMessage" type="error">{{ errorMessage }}</app-alert>
                        <p v-else>Checking code, please wait...</p>
                    </div>

                    <div v-if="step == -1">
                        <app-alert>Welcome! Please follow the steps below to setup your Spotter profile!</app-alert>
                    </div>

                    <app-steps v-if="step >= -1" 
                               :active="step" 
                               finish-status="success" 
                               align-center>
                        <app-step title="Information"/>
                        <app-step title="Notifications"/>
                        <app-step title="Finish"/>
                    </app-steps>

                    <br><br>

                    <div v-if="step == -1">
                        <app-button type="primary" size="large" @click="step = 0">Start</app-button>
                    </div>

                    <div v-if="step == 0">
                        <app-form
                            ref="infoForm"
                            :model="user"
                            :rules="rules"
                            @submit.native.prevent="checkInformation">
                            <grid :columns="['1fr', '1fr']">
                                <grid-item>
                                    <app-form-item label="First Name" prop="first_name">
                                        <app-input
                                            id="first_name"
                                            v-model="user.first_name"
                                            autofocus/>
                                    </app-form-item>
                                </grid-item>
                                <grid-item>
                                    <app-form-item label="Last Name" prop="last_name">
                                        <app-input id="last_name" v-model="user.last_name"/>
                                    </app-form-item>
                                </grid-item>
                            </grid>

                            <app-form-item label="Password" prop="password">
                                <app-input id="password" v-model="user.password" type="password"/>
                            </app-form-item>

                            <app-button type="primary" size="large" native-type="submit">Next</app-button>
                        </app-form>
                    </div>

                    <div v-if="step == 1">
                        <app-alert v-if="errorMessage" type="error">{{ errorMessage }}</app-alert>
                        <app-form ref="notifForm" :model="user" @submit.native.prevent="submit">
                            <app-alert>Pick which notifications you would like to receive</app-alert>
                            <notification-toggles v-model="user" :onboarding="true" />
                            <app-button
                                :loading="loading"
                                type="primary"
                                native-type="submit"
                                size="large">Finish</app-button>
                        </app-form>
                    </div>

                    <div v-if="step == 2">
                        <p>Your account has been created! Follow the link below to login and start using the system.</p>
                        <app-button type="primary" @click="goToLogin">Login</app-button>
                    </div>

                    <router-link :to="{ name: 'login' }">Back to Login</router-link>
                </div>
            </div>
        </section>
    </section>
</template>

<script>
import { mapActions } from 'vuex'
import { first } from '@/utilities'

import NotificationToggles from '../User/NotificationToggles'
export default {
    name: 'invite',
    components: {
        NotificationToggles
    },
    props: ['uuid'],
    head: {
        title: {
            inner: 'Invite'
        }
    },
    data() {
        return {
            step: -2,
            loading: false,
            errorMessage: null,
            user: {
                first_name: '',
                last_name: '',
                tardy_absent_email: true,
                daily_recap_email: false,
                weekly_token_email: false,
                token: this.uuid
            },
            invite: null,
            rules: {
                first_name: [
                    {
                        required: true,
                        message: 'Please enter a first name',
                        trigger: 'blur'
                    }
                ],
                last_name: [
                    {
                        required: true,
                        message: 'Please enter a last name',
                        trigger: 'blur'
                    }
                ],
                password: [
                    {
                        required: true,
                        message: 'Please enter a password',
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    mounted() {
        this.checkCode()
    },
    methods: {
        ...mapActions(['checkInviteCode', 'register']),
        checkCode() {
            this.checkInviteCode(this.uuid)
                .then(valid => {
                    if (valid) {
                        this.step++
                    }
                    this.errorMessage = null
                })
                .catch(({ messages }) => {
                    this.errorMessage = first(messages)
                })
        },
        checkInformation() {
            this.$refs['infoForm'].validate(valid => {
                if (valid) {
                    this.step = 1
                }
            })
        },
        submit() {
            this.loading = true
            this.register(this.user)
                .then(() => {
                    this.loading = false
                    this.step = 2
                })
                .catch(({ messages }) => {
                    this.loading = false
                    this.errorMessage = first(messages)
                })
        },
        goToLogin() {
            this.$router.push({
                name: 'login',
                params: { email: this.user.email }
            })
        }
    }
}
</script>

<style lang="stylus">
@import '../../../stylus/variables'

.auth.invite
    width: 100%
    min-height: 100%
    padding-top: 50px
    padding-bottom: 50px
    height: auto
    z-index: 1
    grid-template-columns: 1fr 2fr 1fr

    @media screen and (max-width: 480px)
        display: block
        padding-left: 10px
        padding-right: 10px

    .auth-logo
        position: relative
        text-align: center

        .auth-shadow
            display: inline-block
            content: ''
            width: 75px
            height: 75px
            box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.3)
            border-radius: 22px

    .auth-error
        background: #FFF
        border-radius: 3px
        font-size: 15px
        color: #FC4545
        padding: 10px 0px

    .auth-body
        background: transparent

    .auth-elements
        background: #FFF
        padding: 20px
        border-radius: 12px
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15)
        text-align: left

        form
            padding: 0px

        .el-steps
            margin: 25px 0px 20px

        .el-form .el-form-item
            margin-bottom: 18px

        .notification-toggles
            margin-top: 10px
</style>
